<template>
  <div class="home-page-view">
    <div class="top-box">
      <div class="user-info">
        <!-- <i class="el-icon-cpu">
          <span>视频插件<img src="/download/hk-video-download.png" alt="海康视频插件"/></span>
        </i> -->
        <i class="el-icon-mobile-phone">
          <span>移动端<img src="/app-download/qr-code.png" alt="二维码下载"/></span>
        </i>
        <i class="el-icon-user" style="font-size:1vw"></i>
        <span style="margin-left: 10px; margin-right: 16px">
          {{ user.realName }} |
        <span @click="loginOut" style="margin-left: 6px; cursor: pointer" >退出</span ></span>
      </div>
    </div>
    <div class="container">
     <div class="left-box">
      <div class="big-title">
        <span class="title-text">智慧园区</span>
      </div>
      <!-- <div class="content-title">
        <span class="body-title-text" @click="goToPage(iocMenu?.sysUrl)">智慧驾驶舱</span>
      </div> -->
      <div class="main-item">
        <div class="inner-item rotate"
          v-for="item in mainMenuList"
          :key="item.key"
        >
          <div class="list-item-box"
              :class="item.class"
              @click="goToPage(item?.sysUrl)"
          >
            <span class="content-name">{{ item.sysName }}</span>
          </div>
        </div>
      </div>
     </div>
     <div class="right-box">
        <div class="content-item"
          v-for="item in otherMenuList"
          :key="item.key"
          @click="goToPage(item?.sysUrl)"
        >
          <span class="content-text" v-if="item.sysName === '预警中心'">
            {{ item.sysName}}
            <span class="content-num">{{ totalCount < 99 ? totalCount : '99+' }}</span>
          </span>
          <span class="content-text" v-else>{{ item.sysName }}</span>
        </div>
     </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Get } from "../utils/khHttp";
import { MessageBox } from "element-ui";
export default {
  name: "HomePage",
  data() {
    return {
      user: {},
      allMenuList:[],
      imgList:[
        'ball-icon-1',
        'ball-icon-2',
        'ball-icon-3',
        'ball-icon-4',
        'ball-icon-5',
        'ball-icon-6',
      ],
      isActive:false,
      totalCount: 0,
      timer:null,
    };
  },
  computed:{
    mainMenuList(){
      return this.allMenuList.filter(item => !item.sysUrl.includes('wisdom-ioc')).slice(0, 6).map((item,index)=>{
        return {
          ...item,
          img:this.imgList[index],
          class:this.imgList[index]
        }
      })
    },
    otherMenuList() {
      if(this.allMenuList.length < 6){
        return [];
      }else{
        return this.allMenuList.slice(6).filter(item=>{
          return !item.sysUrl.includes('wisdom-ioc')
        })
      }
    },
    iocMenu() {
      return this.allMenuList.find(item => item.sysUrl.includes('wisdom-ioc'))
    }
  },
  mounted() {
    this.getSystemList();
    this.getWarnDataCount();
    this.timer = setInterval(() => {
      this.getWarnDataCount();
    }, 5 * 60 * 1000); // 5分钟
  },

  // 添加组件销毁时的清理
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    /**
     * @description 获取预警中心的所有数据
     * @author hu zhen
     * @date 2025/11/27
    **/
    getWarnDataCount(){
      axios.get('/warn-center/api/warnStatistics/statUnFinishWarnCount').then(res=>{
        if(res.data.errCode === 0){
          this.totalCount = res.data.datas.reduce((pre,cur)=>{
            return pre + cur.count
          },0)
        }
      })
    },
    /**
     * @description 获取图片路径
     * @author hu zhen
     * @date 2024/04/01
    **/
    getImagePath(img) {
      return require('@/assets/images/home-view/' + img + '.png');
    },
    /**
     * 退出登录
     * @method
     * @Description: 退出登录
     * @author hu zhen
     * @date 2024/04/01
     */
    loginOut() {
      // 此处请求的Api直接会绕过CAS的校验
      MessageBox.confirm("确认退出当前用户吗?", "提示", {})
        .then(() => {
          Get("/apc/logout", {}).then((res) => {
            if (res) {
              window.location.href = res.logoutUrl;
            } else {
              this.$notify.error({
                title: "错误",
                message: "退出失败,请联系管理员",
              });
            }
          });
        })
        .catch((e) => {
          console.log("$confirm catch" + e);
        });
    },
    /**
     * 跳转指定页面
     * @method
     * @Description: 跳转指定页面
     * @param{String} sysUrl - 系统地址
     * @author hu zhen
     * @date 2024/04/01
     */
     goToPage(sysUrl) {
      sysUrl && window.open(sysUrl)
    },
     /**
     * 获取系统列表数据
     * @method
     * @Description: 获取系统列表数据
     * @author hu zhen
     * @date 2024/04/01
     */
     async getSystemList() {
      const res = await Get("/api/user/listSys", {sysName: "", agentAccount: "", status: ""})
      if (res.errCode === 0) {
        this.user = res.user
        this.allMenuList = res.list.filter(item => item.status === "0")
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$distans: 100px;
$right-distant: 50px;
$total-elements: 6;
@font-face {
  font-family: Alimama_ShuHeiTi_Bold;
  src: url("@/assets/fonts/Alimama_ShuHeiTi_Bold.ttf");
}

.home-page-view {
  height: 100%;
  width: 100%;
  background: url("@/assets/images/home-view/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  overflow: hidden;
  flex-flow: column;
  .top-box {
    height: 50px;
    width: 100%;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: flex-end;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    padding-top: 10px;
    box-sizing: border-box;
    line-height: 22px;

    .user-info{
      color: #fff;
      font-size: 0.8vw;
      padding-right: 31px;
      display: flex;
      align-items: center;
      margin-top: 10px;
    }
  }
  .container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    height: calc(100% - 50px);
    color: #fff;
    .left-box{
      height: 100%;
      width: 80%;
      position: relative;
      .big-title{
        width: 800px;
        height: 116px;
        line-height: 116px;
        position: absolute;
        left: 54%;
        top: 60px;
        transform: translate(-50%,-50%);
        background: url('@assets/images/home-view/title-bg.png') no-repeat;
        background-size: 100% 100%;
        text-align: center; 
        .title-text{
          font-family: Alimama_ShuHeiTi_Bold;
          font-size: 34px;
        }
      }
      .content-title{
        cursor: pointer;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        .body-title-text{
          font-size: 40px;
          font-family: Alimama_ShuHeiTi_Bold;
        }
      }

      .main-item {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;

          .inner-item{
            position: absolute;
            animation: float 3s infinite ease-in-out;
            &:first-child{
              top: -254px;
              left: 200px;
              animation-delay: 0s;
            }

            &:nth-child(2){
              top: -65px;
              left: 397px;
              animation-delay: 0.4s;
            }

            &:nth-child(3){
              top: 121px;
              left: 154px;
              animation-delay: 0.8s;
            }

            &:nth-child(4){
              top: 69px;
              left: -294px;
              animation-delay: 1.2s;
            }

            &:nth-child(5){
              top: -91px;
              left: -542px;
              animation-delay: 1.6s;
            }

            &:nth-child(6){
              top: -286px;
              left: -379px;
              animation-delay: 2s;
            }

            .list-item-box{
              position: relative;
              width: 175px;
              height: 180px;
              background-size: 100% 100%;
              cursor: pointer;

              .content-name{
                position: absolute;
                top: 70%;
                right: 50%;
                transform: translate(50%,15%);
                font-family: Alimama_ShuHeiTi_Bold;
                font-size: 19px;
                width: 100%;
              }
            }
            .ball-icon-1{
              background-image: url('@assets/images/home-view/ball-icon-1.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/ball-icon-1-active.png');
              }
            }
            .ball-icon-2{
              background-image: url('@assets/images/home-view/ball-icon-2.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/ball-icon-2-active.png');
              }
            }
            .ball-icon-3{
              background-image: url('@assets/images/home-view/ball-icon-3.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/ball-icon-3-active.png');
              }
            }
            .ball-icon-4{
              background-image: url('@assets/images/home-view/ball-icon-4.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/ball-icon-4-active.png');
              }
            }
            .ball-icon-5{
              background-image: url('@assets/images/home-view/ball-icon-5.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/ball-icon-5-active.png');
              }
            }
            .ball-icon-6{
              background-image: url('@assets/images/home-view/ball-icon-6.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/ball-icon-6-active.png');
              }
            }
          }

          @keyframes float {
            0% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
            100% {
              transform: translateY(0);
            }
          }
        }
    }
    .right-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 100%;
      width: 20%;
      .content-item{
        // position: absolute;
        display: flex;
        width: 320px;
        height: 88px;
        align-items: center;
        font-family: Alimama_ShuHeiTi_Bold;
        font-size: 18px;
        background: url("@/assets/images/home-view/common-system.png") no-repeat;
        cursor: pointer;
        margin-bottom: 30px;

        &:first-child{
          margin-right: -60px;
        }

        &:nth-child(3){
          margin-right: 60px;
        }

        &:nth-child(4){
          margin-right: 60px;
        }

        &:nth-child(6){
         margin-right: -60px;
         margin-bottom: 0;
        }

        &:hover,&.active{
          background: url("@/assets/images/home-view/common-system-active.png") no-repeat;
        }
        .content-text{
          position: relative;
          padding-left: 34px;
          width: 250px;
          text-align: center;
          .content-num{
            background-color: #f56c6c;
            border-radius: 10px;
            color: #fff;
            display: inline-block;
            font-size: 12px;
            height: 18px;
            line-height: 18px;
            padding: 0 6px;
            text-align: center;
            white-space: nowrap;
            border: 1px solid #fff;
            margin-left: 10px;
            position: absolute;
            top: -10px;
          }
        }
      }
    }
  }
}
.el-icon-mobile-phone,.el-icon-cpu {
  font-size: 1vw;
  font-weight: bold;
  margin-right: 160px;
  cursor: pointer;

  span {
    position: relative;
    font-size: 0.8vw;
    font-weight: normal;
    margin-left: 10px;

    &::before {
      content: '';
      position: absolute;
      top: 40px;
      left: -20px;
      border: 5px solid transparent;
      border-bottom-color: #fff;
      visibility: hidden;
    }

    img {
      position: absolute;
      top: 49px;
      left: -45px;
      width: 120px;
      height: 120px;
      border: 1px solid #fff;
      visibility: hidden;
    }
  }

  &:hover {
    span::before {
      visibility: visible;
    }

    img {
      visibility: visible;
    }
  }
}
</style>
